// extracted by mini-css-extract-plugin
export default {"product_container":"Product_product_container__-tYrM","image":"Product_image__-Cqub","name":"Product_name__6rBLE","price":"Product_price__0wyRi"};